import { combineReducers } from "redux";
import config from "./config";
import campaignList from "./campaignList";
import widgetList from "./widgetList";
import campaignDropDown from "./campaignDropDown";
import user from "./user";
import userSettings from "./userSettings";
import categories from "./categories";
import teaserList from "./teaser_list";
import overview from "./overview";
import spinner from "./spinner";
import closeMenu from "./closeMenu";
import payments from "./payments";
import wmPayments from "./wmPayments";
import payment from "./payment";
import notifications from "./notifications";
import httpErrors from "./httpErrors";

export default combineReducers({
  config,
  user,
  campaignList,
  userSettings,
  widgetList,
  categories,
  closeMenu,
  payments,
  wmPayments,
  payment,
  campaignDropDown,
  teaserList,
  overview,
  spinner,
  notifications,
  httpErrors
});
